@if (isLoading) {
<div>
  <i class="pi pi-spin pi-spinner" style="font-size: 3em"></i>Loading...
</div>
}

@if (errorMessage) {
<div><p-message severity="error" [text]="errorMessage"></p-message></div>
}

@if (workOrder) {
<form id="workOrderForm" #workOrderForm="ngForm" class="container">
  <div class="row iPhoneFix no-gutter container">
    <div class="col-12 col-md-12 col-lg-12 no-gutter container">
      <div class="row no-gutter">
        <div class="col-12 col-md-6 col-lg-6 no-gutter">
          <h4>Wellness Work Order Maintenance</h4>
        </div>
      </div>
      <br>
      <!-- Common top section includes basic WO information such as customer, address, representative, message to customer -->
      <app-work-order-maintenance-common-fields-top [(workOrder)]="workOrder" [isEditable]="isEditable"
        [isCustomer]="isCustomer">
      </app-work-order-maintenance-common-fields-top>
      @if (canReassignRM) {
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="bold">
            Regional Manager
          </div>
          @if (workOrder) {
          <ng-select class="custom" required [searchable]="false" [selectOnTab]="true" [items]="rms"
            placeholder="Select a Regional Manager" name="rep" bindLabel="fullName"
            [(ngModel)]="workOrder.representative" (ngModelChange)="repChanged()" [disabled]="!isEditable || !changeRM">
          </ng-select>
          }
        </div>
      </div>
      }
      @if (workOrder && workOrder.customer && workOrder.customer.customerComments && !isCustomer) {
      <div class="p-col-12 p-md-2">
        @if (workOrder && workOrder.id && workOrder.completionStatus != 'Completed' && workOrder.completionStatus
        !='Unable to be Completed' && !isCustomer && isAdminOrForeman) {
        <p-button fluid type="button" class="smallButton" (click)="onMyWay()" [disabled]="false" label="On My Way" severity="info">
        </p-button>
        }
        @if (!isCustomer) {
        <span class="fine-print" style="text-align: right;">
          Last Sent: {{workOrder.onMyWaLastSent ? (workOrder.onMyWaLastSent | date: 'short') : 'Not Sent'}}
        </span>
        }
        &nbsp;
        @if (workOrder && workOrder.id && workOrder.completionStatus != 'Completed' && workOrder.completionStatus
        !='Unable to be Completed' && !isCustomer && isAdminOrForeman) {
        <p-button fluid type="button" class=" smallButton" severity="warn" (click)="wrappingUp()" [disabled]="false"
          label="Wrapping Up">
        </p-button>
        }
        @if (!isCustomer) {
        <span class="fine-print" style="text-align: right;">
          Last Sent: {{workOrder.wrappingUpLastSent ? (workOrder.wrappingUpLastSent | date: 'short') : 'Not Sent'}}
        </span>
        }
      </div>
      }
      @if (workOrder && !isCustomer && workOrder.completionStatus == 'Completed') {
      <div>
        <p-button severity="info" type="button" class=" smallButton" (click)="duplicateToQuote()" [disabled]="saving"
          label="Duplicate Work Order to New Quote">
        </p-button>
      </div>
      }
      @if (!isCustomer) {
      <div class="row">
        <div class="col-12 col-md-6 multiselect">
          <h6>Required Skill(s)/Certification(s)</h6>
          @if (workOrder) {
          <p-multiselect autofocusFilter placeholder=" " [options]="requiredSkills" name="requiredSkills" [ngModel]="requiredSkills" [panelStyle]="{minWidth:'12em'}"
            fluid optionLabel="name" disabled defaultLabel="">
            <ng-template let-value pTemplate="selectedItems">
              @for (val of value; track val) {
              <div class="ui-multiselected-item-token ui-corner-all">
                <span>{{val.name}}</span>
              </div>
              }
              @if (!value || value.length === 0) {
              <span style="width: 150px;" class="ui-multiselected-empty-token ui-corner-all">No Skills Required</span>
              }
            </ng-template>
            <ng-template let-skill pTemplate="item">
              {{skill.label}}
            </ng-template>
          </p-multiselect>
          }
        </div>
        <div class="col-12 col-md-6 multiselect">
          <h6>Required Equipment Types</h6>
          @if (workOrder) {
          <p-multiselect autofocusFilter placeholder=" " [options]="requiredEquipment" name="requiredEquipment" [ngModel]="requiredEquipment" fluid
            [panelStyle]="{minWidth:'12em'}" optionLabel="name" disabled defaultLabel="">
            <ng-template let-value pTemplate="selectedItems">
              @for (val of value; track val) {
              <div class="ui-multiselected-item-token ui-corner-all">
                <span>{{val.type}}</span>
              </div>
              }
              @if (!value || value.length === 0) {
              <span style="width: 180px;" class="ui-multiselected-empty-token ui-corner-all">No Equipment
                Required</span>
              }
            </ng-template>
            <ng-template let-role pTemplate="item">
              {{role.label}}
            </ng-template>
          </p-multiselect>
          }
        </div>
      </div>
      }
      @if (!isCustomer) {
      <div class="row">
        <div class="col-12 p-md-2" style="text-align: left;">
          <p-button type="button" fluid (click)="addNewWelnessTask()" class="smallButton"
            [disabled]="!isEditable && !canAddTaskToCompletedWO" label="Add Wellness Task"></p-button>
        </div>
      </div>
      }
      <br>
      @if (workOrder) {
      <div class="row">
        @for (wowt of workOrder.workOrderWellnessTasks; track wowt) {
        <div class="col-12 col-md-6 col-lg-4">
          <app-work-order-maintenance-wellness-task-card [workOrderWellnessTask]="wowt" [isEditable]="isEditable"
            [canEditAssignedTasks]="canEditAssignedTasks" [isCustomer]="isCustomer" [customerId]="workOrder.customer.id"
            [quoteNumber]="workOrder.quoteNumber" [hidePrice]="workOrder.hidePrice"
            (completeTaskWithoutPestRecordEvent)="completeWowtWithoutPestRecord($event)"
            (copyWellnessTaskEvent)="copyWellnessTask($event)" (deleteWellnessTaskEvent)="deleteWellnessTask($event)"
            (editWellnessTaskEvent)="editWellnessTask($event)"
            (wellnessTaskToPestAppEvent)="fromWowtToPesticideApplicationRecord($event)"
            (unableToCompleteWellnessTaskEvent)="unableToCompleteWorkTask($event)"
            (undoCompleteTask)="undoCompleteTask($event)">
          </app-work-order-maintenance-wellness-task-card>
        </div>
        }
      </div>
      }
      <div class="row">
        <div class="col-12">
          <div class="bold">Multi-Day Job: </div>
          @if (workOrder) {
          <p-radiobutton name="isMultiday" [value]="true" [(ngModel)]="workOrder.isMultiday"
            [disabled]="!isEditable" required>
          </p-radiobutton>
          <label for="isMultiday">Yes&nbsp;</label>
          }
          @if (workOrder) {
          <p-radiobutton name="isNotMultiday" [value]="false" [(ngModel)]="workOrder.isMultiday"
            [disabled]="!isEditable" required>
          </p-radiobutton>
          <label for="isNotMultiday">No</label>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="bold">Auto Charge Enabled: </div>
          @if (workOrder) {
          <p-radiobutton name="autoCharge" [value]="true" [(ngModel)]="workOrder.autoChargeEnabled"
            [disabled]="!isEditable" required>
          </p-radiobutton>
          <label for="autoCharge">Yes&nbsp;</label>
          }
          @if (workOrder) {
          <p-radiobutton name="notAutoCharge" [value]="false" [(ngModel)]="workOrder.autoChargeEnabled"
            [disabled]="!isEditable" required>
          </p-radiobutton>
          <label for="notAutoCharge">No</label>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h6 class="bold">Outside Expenses: </h6>
          @if (workOrder) {
          <p-radiobutton name="hasRentalExpense" [value]="true" [label]="'Yes'" [(ngModel)]="workOrder.hasRentalExpense"
            [disabled]="!isEditable && !canSaveAfterCompletion" required>
          </p-radiobutton>
          <label for="hasRentalExpense">Yes&nbsp;</label>
          }
          @if (workOrder) {
          <p-radiobutton name="noRentalExpense" [value]="false" [label]="'No'" [(ngModel)]="workOrder.hasRentalExpense"
            [disabled]="!isEditable && !canSaveAfterCompletion" required>
          </p-radiobutton>
          <label for="noRentalExpense">No</label>
          }
        </div>
        @if (workOrder?.hasRentalExpense) {
        <div class="col-12">
          <h6>Outside Cost(s)</h6>
          <p>
            <input pInputText name="rentalCosts" numeric [textMask]="{mask: currencyMask}"
              [(ngModel)]="workOrder.rentalCost" [required]="workOrder.hasRentalExpense"
              [disabled]="!isEditable && !canSaveAfterCompletion" (ngModelChange)="workOrder.rentalCost=$event" />
          </p>
          <h6>Describe Outside Cost(s)</h6>
          <div class="ui-fluid">
            <input pInputText name="rentalDescription" [(ngModel)]="workOrder.rentalDescription"
              [required]="workOrder.hasRentalExpense" [disabled]="!isEditable && !canSaveAfterCompletion" />
          </div>
        </div>
        }
      </div>
      @if (workOrder && workOrder.quoteWorkOrder && !isCustomer) {
      <div class="row">
        <div class="col-12">
          <h6>Quote Uploads</h6>
          <app-blob-manager [angularUpload]="true" [containerName]="'quote'" [parentRecordId]="workOrder.quoteWorkOrder.id"
            [viewOnly]="true"></app-blob-manager>
        </div>
      </div>
      }
      @if (workOrder && !isCustomer) {
      <div class="row">
        <div class="col-12">
          <h6>Upload Phots of Work</h6>
          <app-blob-manager [angularUpload]="true" [containerName]="'wellness-work-order'" [parentRecordId]="workOrder.id"
            [uploadLabel]="'Document/Photo'" [viewOnly]="!canUpload || !save">
          </app-blob-manager>
        </div>
      </div>
      }
      <div>
        @if (workOrder && workOrder.id && workOrder.completionStatus != 'Completed' && workOrder.completionStatus
        !='Unable to be Completed' && !isCustomer) {
        <p-button type="button" fluid class="smallButton disabledButton" (click)="completeWO()" [disabled]="!canCompleteWO" severity="info"
          label="Complete Work Order">
        </p-button>
        }
        @if (workOrder && workOrder.id && canUndoWOCompletion) {
        <p-button severity="info" type="button" class="smallButton" (click)="openUndoWOCompletion()"
          label="Undo Work Order Completion"></p-button>
        }
      </div>
      <!-- Common bottom section includes total information such as price adjustments, subtotal, sales tax, total -->
      @if (workOrder) {
      <app-work-order-maintenance-common-fields-bottom [(workOrder)]="workOrder" [(isEditable)]="isEditable"
        [isCustomer]="isCustomer" [canCompleteWO]="canCompleteWO" [hidePrice]="workOrder.hidePrice"
        (priceAdjustmentDeleted)="deletePriceAdjustment($event)">
      </app-work-order-maintenance-common-fields-bottom>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-12 columnPadding">
      @if (workOrderForm.invalid && workOrderForm.submitted) {
      <div class="alert alert-danger" role="alert">
        There are errors on this page. Please correct the errors and resubmit.
      </div>
      }
    </div>
    <div class="col-12" style="text-align: right;">
      @if (!canSave) {
      <p-button type="button" severity="warn" (click)="cancel('wellness')" label="Back">
      </p-button>
      }
      @if (canSave) {
      <p-button type="button" severity="warn" (click)="cancel('wellness')" [label]="isEditable ? 'Cancel ': 'Back'">
      </p-button>
      }
      @if (canSaveAfterCompletion) {
      <p-button type="button" severity="success" (click)="saveAfterCompletion()" [disabled]="saving" label="Save">
      </p-button>
      }
      @if (canSave && !isCustomer) {
      <p-button type="submit" severity="success" (click)="preSave(workOrderForm)" [disabled]="saving" label="Save">
      </p-button>
      }
    </div>
  </div>
</form>
}

<!-- Add New Wellness Task dialog -->
<!-- Only dialogs inside class scrollableDialog get the CSS for scrolling. Only use scrollableDialog if the dialog actually has enough content that
        it needs to scroll because it looks weird otherwise. -->
@if (displayWellnessTaskDialog) {
<div class="scrollableDialog">
  <p-dialog header="Wellness Task Info" [(visible)]="displayWellnessTaskDialog" [style]="{'width': '760px'}"  [breakpoints]="{'760px': '100vw'}"
    [closable]="true" (visibleChange)="cancelledTask()" [modal]="true" [resizable]="false" [baseZIndex]="10000" [maximizable]="true"
    [focusOnShow]="false" (onHide)="cancelledTask()">
    <app-wellness-task-maintenance (timeToClose)="closedDialog($event)" (cancelled)="cancelledTask($event)"
      (delete)="deleteWellnessTaskByTask($event)" [workOrder]="workOrder" [task]="selectedWellnessTask">
    </app-wellness-task-maintenance>
  </p-dialog>
</div>
}

@if (showUndoCompleteDialog) {
<div>
  @if (showUndoCompleteDialog) {
  <p-dialog header="Undo Work Order Completion" [(visible)]="showUndoCompleteDialog" [modal]="true" [resizable]="false"
    [baseZIndex]="10000" appendTo="body" [focusOnShow]="false">
    <form [formGroup]="commentForm">
      <div class="form-group">
        Please describe the changes you are about to make:
        <textarea pInputTextarea formControlName="description" class="form-control" [required]="true"
          style="width: 100%;" autoResize="autoResize" placeholder="Describe..."></textarea>
      </div>
      <div class="form-group" style="width: 100%; text-align: right">
        <p-button type="button" (click)="closeUndoWOCompletion()" label="Cancel" severity="info"></p-button>
        &nbsp;
        <p-button type="button" type="submit" [disabled]="commentForm.invalid || saving" (click)="undoWOCompletion()"
          label="Submit"></p-button>
      </div>
    </form>
  </p-dialog>
  }
</div>
}